import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import PropTypes from "prop-types";

import { Badge, Toast } from "@features/ui";

import { useBudgetPlan } from "../api";
import { AmountDisplay, BudgetCategoryOptionList } from "../components";

import "./budget-overview.scss";

export const BudgetOverview = ({ onEdit, slideConfigs }) => {
  const { data: budgetPlan } = useBudgetPlan();
  const { budgetTotals, options, taxInfo } = budgetPlan;
  const balanceAmount = taxInfo.netIncome / 12 - budgetTotals.costs;
  const deficitError = balanceAmount < 0;

  return (
    <div className="budget-overview-view">
      <div className="budget-overview-view-summary">
        <AmountDisplay
          className="net-income-amount"
          value={taxInfo.netIncome / 12}
          label="net"
        />
        <FontAwesomeIcon
          className="operator"
          icon={["fa-regular", "fa-minus"]}
        />
        <AmountDisplay
          className="expenses-amount"
          value={budgetTotals.costs}
          label="expenses"
        />
        <FontAwesomeIcon
          className="operator"
          icon={["fa-regular", "fa-equals"]}
        />
        <AmountDisplay
          className={clsx("balance-amount", {
            positive: balanceAmount >= 0,
            negative: balanceAmount < 0,
          })}
          value={balanceAmount}
          label="balance"
        />
      </div>
      <div className="budget-overview-view-answers">
        <div className="budget-overview-view-answers-header">
          <h2>My Answers</h2>
          {/* Subtract one each for savings and emergency */}
          {options?.length && <Badge>{options.length - 2}</Badge>}
        </div>
        {deficitError && (
          <Toast
            title="Deficit"
            message="Update your answers and fix your monthly budget deficit."
            type="error"
            open
          />
        )}
        <div className="budget-overview-view-answers-list">
          <BudgetCategoryOptionList
            budgetPlan={budgetPlan}
            onEdit={onEdit}
            slideConfigs={slideConfigs}
          />
        </div>
      </div>
    </div>
  );
};

BudgetOverview.propTypes = {
  onEdit: PropTypes.func.isRequired,
  slideConfigs: PropTypes.array.isRequired,
};
